export default "__VITE_ASSET__d2d7bef9__"